import { useMemo } from 'react';

import { OrientationEnum, PaperFormatEnum } from '@e-socna/data-layer';

import { useIdFactory } from '../../../hooks/useIdFactory.hook';

export const useEmptyPrinterDoc = () => {
  const { generateId } = useIdFactory();

  const emptyDoc = useMemo(
    () => [
      {
        index: 0,
        orientation: OrientationEnum.Portrait,
        paperFormat: PaperFormatEnum.A4,
        addHeaders: false,
        addFooters: false,
        supportPageCount: false,
        sections: [
          {
            id: generateId(),
            hasPagebreakAfter: false,
            displayPath: undefined,
            title: undefined,
            content: undefined,
            typeId: undefined,
          },
        ],
      },
    ],
    [generateId],
  );

  return { emptyDoc };
};
